module.exports = __webpack_public_path__ + "04_long_black.34d5a227.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_long_black.png
// module id = sMn/
// module chunks = 0